import React from 'react';
import './HamburgerMenu.css';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Shared HamburgerMenu Component
 * Replaces duplicated hamburger menu code across 10+ components
 *
 * @param {Function} onClose - Close the menu
 * @param {Function} onNavigateToLanding - Navigate to landing/home page
 * @param {Function} onNavigateToMyPosts - Navigate to my posts
 * @param {Function} onNavigateToMeinMarktplatz - Navigate to marketplace
 * @param {Function} onNavigateToCourseReview - Navigate to course review
 * @param {Function} onLogout - Logout callback
 * @param {Boolean} isLoggingOut - Loading state for logout
 */
const HamburgerMenu = ({
  onClose,
  onNavigateToLanding,
  onNavigateToMyPosts,
  onNavigateToMeinMarktplatz,
  onNavigateToCourseReview,
  onLogout,
  isLoggingOut = false
}) => {
  const { t } = useLanguage();

  return (
    <>
      {/* Issue #115: Added role="menu" and aria-label for accessibility */}
      <nav className="hamburger-menu" role="menu" aria-label={t('nav.menu') || 'Navigation menu'}>
        {/* Issue #115: Changed div to button for keyboard accessibility */}
        <button type="button" className="menu-item" onClick={onNavigateToLanding} role="menuitem">
          <span className="menu-icon" aria-hidden="true">&#127968;</span>
          <span className="menu-text">{t('nav.home')}</span>
        </button>
        <button type="button" className="menu-item" onClick={onNavigateToMyPosts} role="menuitem">
          <span className="menu-icon" aria-hidden="true">&#128203;</span>
          <span className="menu-text">{t('menu.meinePosts')}</span>
        </button>
        <button type="button" className="menu-item" onClick={onNavigateToMeinMarktplatz} role="menuitem">
          <span className="menu-icon" aria-hidden="true">&#128722;</span>
          <span className="menu-text">{t('menu.meinMarktplatz')}</span>
        </button>
        <button type="button" className="menu-item" onClick={onNavigateToCourseReview} role="menuitem">
          <span className="menu-icon" aria-hidden="true">&#128218;</span>
          <span className="menu-text">{t('courseReview.title')}</span>
        </button>
        <button
          type="button"
          className="menu-item"
          onClick={onLogout}
          disabled={isLoggingOut}
          role="menuitem"
          aria-busy={isLoggingOut}
        >
          <span className="menu-icon" aria-hidden="true">&#128682;</span>
          <span className="menu-text">{isLoggingOut ? t('nav.loggingOut') : t('nav.logout')}</span>
        </button>
      </nav>
      {/* Overlay to close menu when clicking outside */}
      <div className="menu-overlay" onClick={onClose} aria-hidden="true"></div>
    </>
  );
};

export default HamburgerMenu;
